import type { CountableApiResponse, Establishment, SerializedEstablishment } from '@enmon/commons/lib/enmon';

import { BASE_REST_API_URL } from 'common/constants';
import type { EstablishmentsFilter } from 'types/backendGateway/establishmentsApi';
import { BaseApiClient } from '../baseApiClient';

export type GetAllEstablishmentsResponse = CountableApiResponse<SerializedEstablishment[]>;

/**
 * @deprecated Use class instead because there is only one implementation of this interface which makes searching for references
 * more difficult, name shouldn't be prefixed too: https://blog.nette.org/en/prefixes-and-suffixes-do-not-belong-in-interface-names.
 */
export interface IEstablishmentsApiClient {
  findAll: () => Promise<GetAllEstablishmentsResponse>;
  find: (filter: EstablishmentsFilter) => Promise<Establishment>;
}

export class EstablishmentsApiClient extends BaseApiClient implements IEstablishmentsApiClient {
  constructor(jwt: string) {
    super('enmon-tools/establishments', BASE_REST_API_URL, jwt, {
      arrayFormat: 'comma',
    });
  }

  public async findAll(): Promise<GetAllEstablishmentsResponse> {
    const response = await this.axios.get<GetAllEstablishmentsResponse>('', {});

    return response.data;
  }

  public async find(filter: EstablishmentsFilter): Promise<Establishment> {
    const response = await this.axios.get<Establishment>('', { params: filter });

    return response.data;
  }
}
